import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@/config/gameConfig';
import { THEME } from '@/config/theme';
import { drawArcadeBackground, addTextGlow } from '@/utils/arcadeBackground';

export class CreditsScene extends Phaser.Scene {
  constructor() {
    super({ key: 'CreditsScene' });
  }

  create(): void {
    // Fade in
    this.cameras.main.fadeIn(300, 5, 7, 22);

    // Arcade background
    drawArcadeBackground(this);

    // Title with glow
    const title = this.add.text(GAME_WIDTH / 2, 60, 'CREDITS', {
      fontFamily: THEME.fonts.heading,
      fontSize: THEME.sizes.title,
      color: THEME.colors.cyan,
    }).setOrigin(0.5);
    addTextGlow(title, THEME.colors.cyan, 15);

    // Credits list
    const credits = [
      'Serge Knystautas',
      'tyy34',
      'Yerlan Nurtaev (SkyToneStudio)',
      'Tumisu (pixvalen)',
      'flutie8211 (Vicki Hamilton)',
      'TheDigitalArtist (Pete Linforth)',
    ];

    const startY = 200;
    const lineSpacing = 60;

    credits.forEach((name, index) => {
      this.add.text(GAME_WIDTH / 2, startY + index * lineSpacing, name, {
        fontFamily: THEME.fonts.pixel,
        fontSize: THEME.sizes.bodyLarge,
        color: THEME.colors.text,
        stroke: THEME.stroke.color,
        strokeThickness: THEME.stroke.thicknessThin,
      }).setOrigin(0.5);
    });

    // Back button
    this.createButton(100, 60, '← BACK', () => {
      this.transitionTo('MenuScene');
    });

    // Keyboard navigation: Esc, Enter, or Space to go back
    this.input.keyboard?.on('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
        this.transitionTo('MenuScene');
      }
    });
  }

  private createButton(x: number, y: number, text: string, onClick: () => void): void {
    const width = 120;
    const height = 40;
    const fontSize = THEME.sizes.small;

    const bg = this.add.rectangle(x, y, width, height, THEME.colors.primaryHex, 1);
    bg.setStrokeStyle(2, THEME.colors.primaryDarkHex);

    this.add.text(x, y, text, {
      fontFamily: THEME.fonts.pixelBold,
      fontSize,
      color: THEME.colors.textOnPrimary,
    }).setOrigin(0.5);

    bg.setInteractive({ useHandCursor: true });
    bg.on('pointerover', () => bg.setFillStyle(THEME.colors.primaryDarkHex));
    bg.on('pointerout', () => bg.setFillStyle(THEME.colors.primaryHex));
    bg.on('pointerdown', onClick);
  }

  private transitionTo(scene: string, data?: object): void {
    this.cameras.main.fadeOut(200, 5, 7, 22);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start(scene, data);
    });
  }
}
